import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/696326ed7683ed0014e4c731/ecofiber_calculator/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696326ed7683ed0014e4c731/ecofiber_calculator/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696326ed7683ed0014e4c731/ecofiber_calculator/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696326ed7683ed0014e4c731/ecofiber_calculator/src/components/ui/AppImage.tsx");
